var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"spellcheck":"false"}},[_c('router-view'),_c('AppServiceView'),(_vm.isShowLoading)?_c('LoadingComponent'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }